import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Reset() {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [pending, setPending] = useState(false);
  const [email, setEmail] = useState("");
  const location = useLocation();

  useEffect(() => {
    setEmail(location.state.email);
  }, []);

  const handleReset = async () => {
    setPending(true);
    const baseUrl =  "https://us-central1-deft-cef16.cloudfunctions.net/resetPasswordHook";
    const url = encodeURI(`${baseUrl}?email=${email}`);
    try {
      await fetch(url, { mode: 'no-cors'});
      setSuccess(true);
    }
    catch (err) {
      setError(true);
    }
    setPending(false);
  };

  if (pending) {
    return (
      <div className={styles.authContainer}>
        <div className={styles.containerTitle}>Processing</div>
      </div>
    )
  }
  if (error) {
    return (
      <div className={styles.authContainer}>
        <div className={styles.containerTitle}>An error occurred</div>
      </div>
    )
  }
  if (success) {
    return (
      <div className={styles.authContainer}>
        <div className={styles.containerTitle}>Check your email</div>
      </div>
    )
  }
  return (
    <div className={styles.authContainer}>
      <div className={styles.containerTitle}>Reset Password</div>
      <div style={{ marginTop: 20 }}>
        <div>Email</div>
        <input
          className={"input"}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div>
        <button className={styles.authButton} onClick={handleReset}>
          Send Reset Email
        </button>
      </div>
      <div style={{ marginTop: 20 }}>
        Back to{" "}
        <Link className={styles.navLink} to="/auth/login">
          Login
        </Link>
      </div>
    </div>
  );
};
